import { cn } from '@repo/ui/lib/utils';
import { Icon } from './ui/icon';
import { useGlobalPendingState } from 'remix-utils/use-global-navigation-state';

export const Spinner = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        "relative inline-flex size-20 items-center justify-center",
        className
      )}
      role="status"
      aria-live="polite"
    >
      <span className="absolute inset-0 rounded-full border-[3px] border-primary/30" />
      <span className="absolute inset-0 rounded-full border-[3px] border-primary border-t-transparent animate-spin" />
      <Icon name="logo-main" size="xl" className="text-primary" />
      <span className="sr-only">Đang tải</span>
    </div>
  );
};
export function LayoutLoading(){
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/80 backdrop-blur-sm">
      <Spinner />
    </div>
  );
}
export function GlobalPendingUI() {
  const globalState = useGlobalPendingState();
  if (globalState === "idle") return null;

  return <LayoutLoading/>
}
